import { z } from "zod";
import { supportUrl } from "@/config/get-public-env";
import { verifyExternalAddress, verifyRoutePath } from "./verify-site-layout";

/** Where a link goes: nowhere yet, the help centre address of this installation, an outside address, a page of this app, or a page built in the Pages app. */
export const siteTargetSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("none") }),
  z.object({ type: z.literal("support") }),
  z.object({ type: z.literal("external"), url: z.string().refine((v) => verifyExternalAddress(v).ok) }),
  z.object({ type: z.literal("route"), path: z.string().refine((v) => verifyRoutePath(v).ok) }),
  z.object({ type: z.literal("page"), slug: z.string().regex(/^[a-z0-9]+(-[a-z0-9]+)*$/).max(100) }),
]);

export type SiteTarget = z.infer<typeof siteTargetSchema>;

/** An empty target of the chosen kind, for the editor to fill in. */
export function blankTarget(type: SiteTarget["type"]): SiteTarget {
  if (type === "external") return { type, url: "" };
  if (type === "route") return { type, path: "/" };
  if (type === "page") return { type, slug: "" };
  return { type };
}

/** The address a menu or footer link points to, in the reader's language. */
export function targetHref(target: SiteTarget, locale: string): string {
  switch (target.type) {
    case "none": return "#";
    case "support": return supportUrl(locale);
    case "external": return target.url;
    case "route": return `/${locale}${target.path}`;
    case "page": return `/${locale}/pages/${target.slug}`;
  }
}
